import { TLinkForm } from '../types/responses/video';
import { EPlayerMode } from '../types/video';
import { ModeSettings } from './link-settings_by_mode';

const baseLinkSettings: TLinkForm = {
  viewingGuarantee: true,
  volumeLimit: false,
  volumeLimitValue: 0,
  increaseAttention: false,
  increaseAttentionValue: 0,
  rewindOption: false,
  distanceControl: false,
  videoSpeedControl: false,
  videoRecommendations: false,
  minimumAttentionLimit: false,
  minimumAttentionLimitValue: 0,
  attentionLimit: false,
  title: '',
  playerMode: EPlayerMode.CustomSettings,
  captionsEnabled: false,
  captions: '',
  documentAutoScroll: false,
  documentDefaultSpeed: 0.2,
  documentRequiredCoverage: 95,
  documentAttentionThreshold: 35,
};

export const getDefaultLinkSettings = (
  playerMode: EPlayerMode = EPlayerMode.Training
): TLinkForm => ({
  ...baseLinkSettings,
  ...ModeSettings[playerMode],
  playerMode,
});
